import React from 'react';

const LanternalLogo = ({ size = 35, environment, ...props }) => {
  const logoSrc = environment === 'Production' ? '/static/Lantern_Icon_Gold.svg' : '/static/Lantern_Icon_White.svg';
  return <img alt="Lantern Logo" src={logoSrc} style={{ width: size, height: size }} {...props} />;
};

export default LanternalLogo;
